import React, {useState, useEffect, useRef, useContext} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {functions} from "../../../constants/common-functions";
import {STRINGIFY} from "../../../constants/general-constants";
import {store} from '../../../context/store';

export default function PhotoTourZipPanel({id, photoTourZip, reloadFunction}){
	const globalState = useContext(store);
	const [thisName, setThisName] = useState("");
	const [userName, setUserName] = useState("");
	const [facilityName, setFacilityName] = useState("");
	const [fileName, setFileName] = useState("");
	const [isComplete, setIsComplete] = useState(false);
	const [label, setLabel] = useState("");
	const [facilityCode, setFacilityCode] = useState("");
	
	const	[commentsPositionTop, setCommentsPositionTop] = useState("0px");
	const [comments, setComments] = useState("");
	const [displayComments, setDisplayComments] = useState("none");
	
	useEffect(() => {
		if(photoTourZip){
			setThisName(photoTourZip.name);
			setUserName(photoTourZip.userName);
			setFacilityName(photoTourZip.facilityName);
			setFileName(photoTourZip.fileName);
			setComments(photoTourZip.comments);
			setIsComplete(photoTourZip.isComplete);
			setLabel(photoTourZip.name + " (Property: " + photoTourZip.facilityName + " by " + photoTourZip.userName + ")");
			functions.getArrayFromAjax("/resolution/facility?id=" + photoTourZip.facilityId, null, populateFacility);
		}
		
	}, [photoTourZip, id]);
	
	const populateFacility = (facility) => {
		setFacilityCode(facility.code);
	};
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 40px)",
		backgroundColor:"#eee",
		borderRadius:"4px",
		minHeight:"40px",
		marginTop:"10px",
		alignItems:"center",
		justifyContent:"space-between",
		marginLeft:"20px"
	};
	
	const labelContainer = {
		display:"flex",
		marginLeft:"20px",
		fontSize:"12px",
		color:"black"
	};
	
	const buttonContainer = {
		display:"flex"
	};
	
	const blueButton = {
		display:"flex",
		width:"100px",
		height:"30px",
		alignItems:"center",
		color:"white",
		backgroundColor:DEFAULT_BLUE,
		cursor:"pointer",
		justifyContent:"space-around",
		borderRadius:"4px",
		fontSize:"12px",
		margin:"5px"
	};
	
	const getSubmitObject = () => {
		let submitObject = {
			id:id,
			submissionDate:photoTourZip.submissionDate,
			name:photoTourZip.name,
			comments:photoTourZip.comments,
			facilityId:photoTourZip.facilityId,
			userId:photoTourZip.userId,
			fileName:photoTourZip.fileName,
			isComplete:true
		};
		console.log(submitObject);
		return submitObject;
	};
	
	const goDownload = () => {
		let url = globalState.state.client.resourceFolderUrl + "/phototourzips/" + facilityCode + "/" + fileName;
		functions.downloadFile(fileName, url, handleCloseClick);
	};
	
	const handleCloseClick = () => {
		
	};
	
	const goSubmit = () => {
		functions.submitAjax("/resolution/phototourzipsave", 
				getSubmitObject(), closeEdit,  STRINGIFY, handleSubmitError);
	};
	
	
	const handleSubmitError = (e) => {
		alert(e);
		closeEdit();
	};
	
	const closeEdit = () => {
		reloadFunction();
	};
	
	const getCompleteButton = () => {
		if(isComplete === false){
			return <div style={blueButton} onClick={goSubmit}>
					Mark Complete
			</div>;
		}
		else{
			return <div/>;
		}
	};
	
	const commentsBox = {
		position:"fixed",
		right:"140px",
		top:commentsPositionTop,
		display:displayComments,
		width:"300px",
		minHeight:"200px",
		padding:"20px",
		backgroundColor:"white",
		color:"black",
		fontSize:"12px",
		boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)',
		borderRadius:"4px"
	};
	
	const goComments = (event) => {
		if(displayComments === "flex"){
			setDisplayComments("none");
		}
		else{
			setCommentsPositionTop(event.target.getBoundingClientRect().top - 60);
			setDisplayComments("flex");
		}
	};
	
	return (
		<div style={thisContainer}>	
			<div style={labelContainer}>
					{label}
			</div>
			<div style={buttonContainer}>
				{getCompleteButton()}
				<div style={blueButton} onClick={goDownload}>
				 	Download Zip
				</div>
				<div style={blueButton} onClick={goComments}>
				 	Comments
				</div>
			</div>
			<div style={commentsBox}>
				{comments}
			</div>
		</div>
		
	);
}